// Global sticky "back to top" button. Shows after scrolling past a
// threshold, scrolls to top on click. Respects prefers-reduced-motion
// (instant jump instead of a smooth animated scroll).
(function () {
  function init() {
    var btn = document.getElementById('BackToTop');
    if (!btn) return;

    var THRESHOLD = 600;
    var ticking = false;

    function updateVisibility() {
      ticking = false;
      btn.hidden = window.scrollY < THRESHOLD;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }, { passive: true });

    updateVisibility();

    /* Stack the Shopify Inbox chat pill 12px above this button, wherever the button is
       (its bottom changes on the PDP while the sticky add-to-cart bar is shown). The pill
       lives in the <shopify-chat> host's shadow DOM at an inner offset that differs per
       browser, so the host is nudged by the measured difference instead of a fixed value. */
    var GAP = 12;
    var host = null;
    var nudging = false;
    /* the launcher button sits in a nested shadow root (2026 agent chat: shopify-chat ->
       inner element -> button.activator); search every open shadow root, prefer .activator */
    var pill = null;
    function findPill(root, depth) {
      if (!root || depth > 4) return null;
      var hit = root.querySelector('button.activator, .activator');
      if (hit) return hit;
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot) {
          var deep = findPill(nodes[i].shadowRoot, depth + 1);
          if (deep) return deep;
        }
      }
      return depth > 0 ? root.querySelector('button, a, [role="button"]') : null;
    }
    function pillRect() {
      if (!pill || !pill.isConnected) pill = findPill(host.shadowRoot, 1);
      if (!pill) return null;
      var r = pill.getBoundingClientRect();
      return r.height > 0 ? r : null;
    }
    /* distance from the viewport bottom to the arrow's top edge; read from the visible
       arrow, cached while it is hidden (no hidden-toggle + measure = no forced reflow) */
    var arrowFromBottom = null;
    function arrowTop() {
      if (!btn.hidden) {
        var br = btn.getBoundingClientRect();
        arrowFromBottom = window.innerHeight - br.top;
        return br.top;
      }
      if (arrowFromBottom === null) {
        var cs = getComputedStyle(btn);
        arrowFromBottom = (parseFloat(cs.bottom) || 0) + (parseFloat(cs.height) || 44);
      }
      return window.innerHeight - arrowFromBottom;
    }
    function placeChat() {
      if (nudging) return;
      host = host || document.querySelector('shopify-chat');
      if (!host || host.hasAttribute('open')) return;
      var pr = pillRect();
      if (!pr) return;
      var wantedPillBottom = arrowTop() - GAP; /* viewport y the pill's bottom edge should be at */
      var delta = pr.bottom - wantedPillBottom; /* >0: pill too low, lift the host */
      if (Math.abs(delta) < 1) return true;
      var current = parseFloat(host.style.bottom) || parseFloat(getComputedStyle(host).bottom) || 0;
      nudging = true;
      host.style.setProperty('bottom', (current + delta) + 'px', 'important');
      requestAnimationFrame(function () { nudging = false; });
      return true;
    }
    /* wait for the app embed's pill (it mounts late), place it once, re-check once after
       its entrance animation, then stop - no layout reads on a timer for the whole page life */
    var tries = 0;
    var placed = false;
    var waitForChat = setInterval(function () {
      tries += 1;
      if (!placed) {
        host = document.querySelector('shopify-chat');
        if (host && placeChat()) {
          placed = true;
          setTimeout(function () { requestAnimationFrame(placeChat); }, 1500);
          clearInterval(waitForChat);
        }
      }
      if (tries > 30) clearInterval(waitForChat); /* ~30s; after that the first scroll still places it */
    }, 1000);
    var placeQueued = false;
    function queuePlace() {
      if (placeQueued) return;
      placeQueued = true;
      requestAnimationFrame(function () {
        placeQueued = false;
        if (!placed) { host = document.querySelector('shopify-chat'); if (!host) return; }
        if (placeChat()) placed = true;
      });
    }
    window.addEventListener('resize', function () { arrowFromBottom = null; queuePlace(); }, { passive: true });
    window.addEventListener('scroll', queuePlace, { passive: true });
    document.addEventListener('shopify:section:load', function () { arrowFromBottom = null; queuePlace(); });

    btn.addEventListener('click', function () {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
